<div class="consent-body" *appTranslate="let t">
  <div *ngIf="!isNil(termsAndConditions)" id="wrapper" class="card">
    <app-terms-and-conditions [termsAndConditions]="termsAndConditions" (consentGiven)="processConsent($event)" />
  </div>
</div>
